import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import LightBox from 'vue-image-lightbox'
import { swiperConfig } from '../lib/swiper-config.js';
import { mountEvents } from '../lib/swiper-events.js';

Vue.use(VueAwesomeSwiper);
Vue.component("lightbox", LightBox);

Vue.component('image-gallery', {
    data: function () {
        return {
            lightboxMedia: [],
            options: {
                ...swiperConfig,
                slidesPerView: 1,
                spaceBetween: 10,
                slidesPerGroup: 4,
                loop: false,
                loopFillGroupWithBlank: false,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                    },
                    992: {
                        slidesPerView: 4
                    },
                }
            },
            showLightbox: function (id, idx) {
                let vm = this;
                let lightbox = vm.$refs['lightbox-' + id];
                if (lightbox) {
                    vm.lightboxMedia.splice(0, vm.lightboxMedia.length);
                    let gallery = vm.$refs['gallery-' + id];
                    let slides = gallery.querySelectorAll(".slide-for-" + id);
                    slides.forEach(function (it) {
                        let img = it.firstChild;
                        let m = {
                            thumb: img.getAttribute("src"),
                            src: img.getAttribute("src"),
                            caption: it.getAttribute("data-caption")
                        }
                        vm.lightboxMedia.push(m);
                    });
                    lightbox.showImage(idx);
                }
            }
        }
    },
    mounted() {
        mountEvents(this.$el, this.$refs.imageGallery)
    }
});


